import React from 'react';
import I18n from 'i18n-react';

import ReactDefaultBatchingStrategy from 'react-dom/lib/ReactDefaultBatchingStrategy';
import LogService from './services/log/LogService';
import FeatureService from '../src/services/feature/FeatureService';
import Features from '../src/const/Features';

let isHandlingError = false;
const ErrorHandler = {
  get isBatchingUpdates() {
    return ReactDefaultBatchingStrategy.isBatchingUpdates;
  },

  setIsHandlingError(value) {
    isHandlingError = value;
  },

  batchedUpdates(...args) {
    try {
      ReactDefaultBatchingStrategy.batchedUpdates(...args);
    } catch (error) {
      if (isHandlingError) {
        throw error;
      }

      this.setIsHandlingError(true);
      try {
        LogService.error(error.message, JSON.stringify(error.stack), {});
      } finally {
        this.setIsHandlingError(false);
      }
    }
  },

  handler(status, body, isCallCenter){
    let message;
    let isRedirect = true;

    switch(status){
      case 403:
        message = this.forbidenError(body);
        break;
      case 422:
        message = this.unprocessableEntity(body);
        break;
      case 500:
        message = this.internalServerError(body, isCallCenter);
        isRedirect = body.code === "514" ? false : isRedirect;
        break;
      default:
        message = this.defaultError(body);
        break;
    }
    return [isRedirect, message];
  },

  forbidenError(body) {
    return body.message === 'msg.error.jwt' ? I18n.translate('home.msg.session.expired') : this.defaultError(body);
  },

  unprocessableEntity(body) {
    let message;
    if(body.code === 'msg.error.validatePoints.different.price'){
      return message = I18n.translate('components.checkoutInfo.errorMsg.validatePointsDifferentPrice');
    }
    if(body.code === 'msg.error.amadeus.addMultiElement.nameTooLong'){
        FeatureService.isFeatureEnabled(Features.CHECK_ITEM_TOO_LONG_ERROR).then(isEnabled => {
          if (isEnabled) {
            message = (
              <div>
                {I18n.translate('components.checkoutInfo.errorMsg.nameTooLong.title')} <br />
                {I18n.translate('components.checkoutInfo.errorMsg.nameTooLong.subtitle')} <br />
                <strong>
                  <a
                    href={`tel:${I18n.translate(
                      'components.checkoutInfo.errorMsg.nameTooLong.phone'
                    )}`}>
                    {I18n.translate('components.checkoutInfo.errorMsg.nameTooLong.phone')}
                  </a>
                </strong>
              </div>
            );
            return message;
          }
          return message = I18n.translate('home.msg.error') + '\n reason: ' + body.reason;
      });
    }
    return this.defaultError(body);
  },
  
  internalServerError(body, isCallCenter) {
    if(body.code === "512"){
      let telLabelCapital = I18n.translate('components.loginCallcenter.tudoAzulTel');
      let telLabelGeral = I18n.translate('components.loginCallcenter.tudoAzulTelGlobal');
      let telCapital = <a className='CheckoutContainer__telefone' href={`tel:${telLabelCapital}`}> {telLabelCapital} </a>;
      let telGeral = <a className='CheckoutContainer__telefone' href={`tel:${telLabelGeral}`}> {telLabelGeral} </a>;
      return isCallCenter ? I18n.translate("checkout.errors.callCenter.cabinDetailsNull") : I18n.translate(body.message, {telCapital, telGeral});
    }
    if(body.code === "513"){
      return I18n.translate(body.message);
    }
    if(body.code === "514"){
      return I18n.translate(body.message);
    }
    return this.defaultError(body);    
  },

  defaultError(body) {
    let error;
    if (body.reason != null && body.description != null) {
       error= (
        <div>
          <row>{I18n.translate('home.msg.error')}</row>
          <br />
          <row>Description: </row>
          <row>{body.description}</row>
          <br />
          <row>Reason: </row>
          <row>{body.reason}</row>
        </div>
      );
    } else if (body.description != null) {
      error = (
        <div>
          <row>{I18n.translate('home.msg.error')}</row>
          <br />
          <row>Description: </row>
          <row>{body.description}</row>
        </div>
      );
    } else {
      error = I18n.translate('home.msg.error');
    }
    return error;
  }
};

export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/errorHandler.js